import React from 'react';
import classNames from 'classnames';
import { Block, MsOfficeBlockContent, RenderMode } from '../types';
import { BlockContentContainer } from '../components/block/content-container';
import { UploadProgressIndicatorButton } from '../components/block/upload-progress-indicator-button';
import { ViewMicrosoftFile } from 'src/common/ViewMicrosoftFile';
import { FileStrongIcon } from 'src/monet/icons';

type Props = {
  block: Block;
  selected: boolean;
  grabbing: boolean;
  contextMenuOpen: boolean;
  renderMode: RenderMode;
  onUploadCancel: () => void;
  pdfPreview?: boolean;
};

export const MsOfficeBlock = ({ selected, grabbing, contextMenuOpen, renderMode, block, onUploadCancel, pdfPreview = false }: Props) => {
  const blockContent = block.content as MsOfficeBlockContent;
  const isUploading = blockContent.fileUploadStatus === 'in-progress';

  return (
    <BlockContentContainer
      loading={false}
      selected={selected}
      grabbing={grabbing}
      renderMode={renderMode}
      backgroundStyle='solid'
      contextMenuOpen={contextMenuOpen}
    >
      {blockContent.url && (
        pdfPreview ? (
          <div className='w-full h-full flex items-center justify-center bg-neue-canvas-fg-10 rounded-2xl'>
            <div className='flex flex-col items-center gap-2 text-neue-canvas-fg-50'>
              <FileStrongIcon className='w-12 h-12' />
              <span className='text-neue-canvas-desktop-caption'>Microsoft Office Document</span>
            </div>
          </div>
        ) : (
          <ViewMicrosoftFile url={blockContent.url} className='rounded-2xl' />
        )
      )}
      <div
        className={classNames('absolute top-4 right-4 transition', {
          'opacity-0': !isUploading,
          'opacity-100': isUploading,
        })}
      >
        {isUploading && (
          <UploadProgressIndicatorButton
            blockId={block.id}
            onUploadCancel={onUploadCancel}
            blockContent={blockContent}
          />
        )}
      </div>
      <div
        className={classNames('absolute inset-0 rounded-2xl transition bg-transparent z-20', {
          hidden: renderMode === 'player' || selected,
          'pointer-events-none': selected,
        })}
      ></div>
    </BlockContentContainer>
  );
};
